import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-imap-mailbox-lookup',
  templateUrl: './micro-imap-mailbox-lookup.component.html'
})
export class MicroImapMailboxLookupComponent  {

  @Input()
  imapMailboxId:any;

  @Input()
  link:boolean = true;
}
